import axios from "@/lib/axios";

export const fetchQueue = async (params = {}) => {
  const { data } = await axios.get("/followups/queue", { params });
  return data;
};

export const logFollowUp = async (payload) => {
  const { data } = await axios.post("/followups/log", payload);
  return data;
};

export const assignSponsors = async (payload) => {
  const { data } = await axios.post("/followups/assign", payload);
  return data;
};

export const fetchHistory = async (sponsorshipId) => {
  const { data } = await axios.get(`/followups/history/${sponsorshipId}`);
  return data;
};

export const fetchFollowUpUsers = async () => {
  const { data } = await axios.get("/followups/users");
  return data;
};

export const fetchFollowUpMeta = async (params = {}) => {
  const { data } = await axios.get("/followups/meta", { params });
  return data;
};

export const fetchCalendarData = async (params = {}) => {
  const { data } = await axios.get("/followups/calendar", { params });
  return data;
};

export const fetchAnalytics = async (params = {}) => {
  const { data } = await axios.get("/followups/analytics", { params });
  return data;
};

export const fetchAnalyticsDetail = async (params = {}) => {
  const { data } = await axios.get("/followups/analytics/detail", { params });
  return data;
};

export const runCleanup = async () => {
  const { data } = await axios.post("/followups/cleanup");
  return data;
};

export const checkMissedInstalments = async () => {
  const { data } = await axios.post("/followups/check-missed");
  return data;
};

export const clearStaleFollowUp = async ({
  sponsorshipId,
  clearCommitment = false,
  clearPlan = false,
}) => {
  const { data } = await axios.delete(`/followups/${sponsorshipId}/stale`, {
    data: { clearCommitment, clearPlan },
  });
  return data;
};

export const deleteFollowUpLog = async ({
  logId,
  clearCommitment = false,
  clearPlan = false,
  resetFollowUpStatus = false,
  decrementFailedAttempts = false,
}) => {
  const { data } = await axios.delete(`/followups/logs/${logId}`, {
    data: {
      clearCommitment,
      clearPlan,
      resetFollowUpStatus,
      decrementFailedAttempts,
    },
  });
  return data;
};

export const exportQueue = async (params = {}) => {
  const { data } = await axios.get("/followups/export", {
    params,
    responseType: "blob",
  });
  return data;
};
